import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  selectBannersData,
  selectDiscountBanner,
  selectIsDiscountBannerShown,
} from '@lib/core/banners/selectors/banners';
import { actionSetDiscountBanner, actionSetIsDiscountVoucherShown } from '@lib/core/banners/slices/banners';
import { useRetailer } from '@lib/core/retailers/hooks/useRetailer';
import { isApplicationKiosk } from '@lib/core/service/consts';
import { useUser } from '@lib/core/users/hooks';
import { RouteUtils } from '@lib/tools/routes';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';
import { PAGES } from '@lib/tools/views/urls';

export const useDiscountBanner = () => {
  const dispatch = useTypedDispatch();

  const { retailerTags } = useRetailer();
  const { userBestMatchCharacterForCurrentServiceProductCategory, isUserAuthenticated } = useUser();
  const discountCoupon = retailerTags?.discountCoupon;

  const discountBanner = useSelector(selectDiscountBanner);
  const bannersData = useSelector(selectBannersData);
  const isDiscountVoucherShown = useSelector(selectIsDiscountBannerShown);
  const isDiscountBannerFeatureActive = discountBanner && !!discountCoupon;

  useEffect(() => {
    if (discountBanner || isApplicationKiosk || !bannersData?.length) return;

    const newDiscountBanner =
      bannersData.find(({ linkParams }) => {
        const params = new URLSearchParams(linkParams || '');
        return params.get('bannerType') === 'discount';
      }) || null;

    if (newDiscountBanner) {
      dispatch(actionSetDiscountBanner(newDiscountBanner));
    }
  }, [bannersData]);

  const shouldShowDiscountVoucher =
    !!userBestMatchCharacterForCurrentServiceProductCategory &&
    !isDiscountVoucherShown &&
    isUserAuthenticated &&
    !!isDiscountBannerFeatureActive &&
    RouteUtils.currentPageContains(PAGES.vinhood.catalog);
  const shouldShowDiscountBanner =
    !!userBestMatchCharacterForCurrentServiceProductCategory &&
    isUserAuthenticated &&
    !!isDiscountBannerFeatureActive &&
    RouteUtils.currentPageContains(PAGES.vinhood.catalog);

  const setIsDiscountVoucherShown = (isShown: boolean) => dispatch(actionSetIsDiscountVoucherShown(isShown));

  return {
    discountCoupon,
    isDiscountVoucherShown,
    setIsDiscountVoucherShown,
    shouldShowDiscountBanner,
    shouldShowDiscountVoucher,
  };
};
